import { useEffect, useState } from 'react';
import { useUIStore } from '@/store';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme, zoom } = useUIStore();
  const [hasHydrated, setHasHydrated] = useState(false);

  // Track Zustand persist rehydration
  useEffect(() => {
    // Check if already hydrated (for fast refresh / hot reload)
    if (useUIStore.persist.hasHydrated()) {
      setHasHydrated(true);
      return;
    }

    // Listen for hydration completion
    const unsubscribe = useUIStore.persist.onFinishHydration(() => {
      setHasHydrated(true);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
  }, [theme]);

  useEffect(() => {
    // Don't update zoom until Zustand has rehydrated from localStorage.
    // The inline script in layout.tsx already sets zoom correctly on first render.
    // Without this guard, we'd overwrite the correct value with the default (100)
    // before rehydration completes, causing portal positioning issues.
    if (!hasHydrated) return;

    const zoomFactor = zoom / 100;
    document.body.style.zoom = zoomFactor.toString();
    // Set CSS custom property to compensate height for zoom
    document.documentElement.style.setProperty('--zoom-factor', zoomFactor.toString());
  }, [zoom, hasHydrated]);

  return <>{children}</>;
}
